import { useEffect, useState } from 'react';
import { hasMadeChoice, onConsentChange } from '../utils/consent.js';
import { buildCtaUrl } from '../utils/attribution.js';
import { demoLinkProps } from '../utils/calendly.js';

const APP_STORE = 'https://apps.shopify.com/account-editor';

// Persistent install/demo bar for small screens. The header CTA collapses into
// the drawer at <=960px, so this keeps a one-tap conversion path always in reach.
// Visibility is CSS-gated to mobile/tablet; here we only gate on scroll depth,
// cookie-banner state (avoid bottom overlap), and proximity to the footer.
export default function MobileCtaBar() {
  const [visible, setVisible] = useState(false);
  // Read consent after mount, not during the first render: prerendered HTML has
  // no consent, so a returning visitor's first render must match that.
  const [consentResolved, setConsentResolved] = useState(false);

  useEffect(() => {
    setConsentResolved(hasMadeChoice());
    return onConsentChange(() => setConsentResolved(hasMadeChoice()));
  }, []);

  useEffect(() => {
    const update = () => {
      const y = window.scrollY;
      const docH = document.documentElement.scrollHeight;
      const nearBottom = y + window.innerHeight >= docH - 260;
      setVisible(y > 480 && !nearBottom);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  if (!consentResolved) return null;

  return (
    <div
      className={`mobile-cta${visible ? ' is-visible' : ''}`}
      role="region"
      aria-label="Get Account Editor"
      aria-hidden={visible ? undefined : 'true'}
    >
      <a
        href={buildCtaUrl(APP_STORE, 'sticky-install')}
        target="_blank"
        rel="noopener"
        className="btn btn--primary mobile-cta__btn"
        tabIndex={visible ? undefined : -1}
      >
        Install Free
        <i className="ph ph-arrow-right" aria-hidden="true"></i>
      </a>
      <a
        {...demoLinkProps('sticky-demo')}
        className="btn btn--secondary mobile-cta__btn"
        tabIndex={visible ? undefined : -1}
      >
        <i className="ph ph-calendar-dots" aria-hidden="true"></i>
        Book a Demo
      </a>
    </div>
  );
}
